<template>
  <v-toolbar
    color="brand-beige"
    elevation="0"
    style="position: fixed; width: 100%; z-index: 1;"
  >
    <v-container
      fluid
      ma-0
      pa-0
    >
      <v-row no-gutters>
        <v-col
          cols="12"
          lg="10"
          offset-lg="1"
        >
          <div class="d-flex">
            <v-btn
              v-if="StoreInfo"
              class="pa-0 brand-green-dark--text"
              color="transparent"
              depressed
              height="48"
              large
              style="min-width: 25px;"
              @click="onSelectShopClick()"
            >
              <v-avatar
                class="ml-1"
                color="brand-green-dark"
                size="40"
                style="border: var(--v-brand-green-dark-base) solid 1px;"
              >
                <img :src="StoreInfo.Logo">
              </v-avatar>

              <span class="brand-text-title mx-2 hidden-xs-only">
                {{ toLocaleUpperCase(StoreInfo.Name) }}
              </span>

              <v-icon>
                mdi-chevron-down
              </v-icon>
            </v-btn>

            <v-tabs
              v-if="StoreMenu"
              v-model="selectedTab"
              background-color="transparent"
              class="rounded"
              color="brand-primary"
              hide-slider
              light
              style="width: 0"
            >
              <template v-for="(category, idx) in StoreMenuCategories">
                <v-tab
                  v-if="category.Status"
                  :key="`category-${category.Id}-${idx}`"
                  :tab-value="`tab-${getTranslatedField(category, 'Slug')}`"
                  active-class="brand-primary brand-green-dark--text"
                  class="v-btn--outlined brand-green--text px-4 mx-2 brand-text-title"
                  @click="onCategoryClick(category)"
                >
                  {{ toLocaleUpperCase(getTranslatedField(category)) }}
                </v-tab>
              </template>
            </v-tabs>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-toolbar>
</template>

<script>
import StoreCatalogToolbarMixin from '@/theme/default/components/store/StoreCatalogToolbar.js'

export default {
  name  : 'StoreCatalogToolbar',
  mixins: [StoreCatalogToolbarMixin]
}
</script>

<style scoped src="@/theme/default/components/store/StoreCatalogToolbar.css"></style>

<style scoped>
:deep(.v-slide-group__next), :deep(.v-slide-group__prev) {
  flex: 0 1 32px !important;
  min-width: 32px !important;
}

:deep(.v-slide-group__next--disabled), :deep(.v-slide-group__prev--disabled) {
  flex: 0 1 0 !important;
  min-width: 0 !important;
}
</style>
